import React, {Fragment, memo} from 'react';
import PropTypes from 'prop-types';
import {default as StarRating} from '@homeaway/react-star-rating';

const Rating = ({averageRating, reviewCount}) => {
    return (
        <Fragment>
            <span className="text-muted bullet-divider">
                {String.fromCharCode(8226)}
            </span>
            <span className="nowrap">
                <StarRating rating={averageRating} size="12" />
                {` (${reviewCount})`}
            </span>
        </Fragment>
    );
};

Rating.propTypes = {
    averageRating: PropTypes.number,
    reviewCount: PropTypes.number,
};

Rating.defaultProps = {
    averageRating: 0,
    reviewCount: 0,
};

export default memo(Rating);
